import gql from "graphql-tag";

export const MY_LEAVE_GET_FILTERED_TYPES = gql`
  query filteredLeaveTypes {
    filteredLeaveTypes {
      code
      name
      type
      show
      isSelectable
    }
  }
`;
